import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'round' })
export class RoundPipe implements PipeTransform {
  transform(input: number, step?: number): any {
    if (input === undefined) {
      return '--';
    }
    if (step === 0) {
      return Math.round(input);
    }
    if (!step) {
      step = 1;
    }
    return Math.floor(input / step) * step;
  }
}
